import { ActivatedRoute } from '@angular/router';
import { ModalContainerService, ModalService, UserService, BaseModalContainer } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { VrstaDatumaPoreskeObaveze } from './vrsta-datuma-poreske-obaveze'

@Component({
  selector: 'yt-vrsta-datuma-poreske-obaveze',
  templateUrl: './vrsta-datuma-poreske-obaveze.component.html'
})
export class VrstaDatumaPoreskeObavezeComponent extends BaseModalContainer<VrstaDatumaPoreskeObaveze> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaDatumaPoreskeObaveze>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}